"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermFunctionLesserThanEqual = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
class TermFunctionLesserThanEqual extends bus_function_factory_1.TermFunctionBase {
    equalityFunction;
    lessThanFunction;
    constructor(equalityFunction, lessThanFunction) {
        super({
            arity: 2,
            operator: utils_expression_evaluator_1.SparqlOperator.LTE,
            overloads: (0, utils_expression_evaluator_1.declare)(utils_expression_evaluator_1.SparqlOperator.LTE)
                .set(['term', 'term'], exprEval => ([first, second]) => {
                // X <= Y -> X = Y || X < Y
                // We must ensure correct handling of errors following logical-or semantics.
                // First check if the first is lesser than the second.
                let lessThanError;
                try {
                    if (this.lessThanFunction.applyOnTerms([first, second], exprEval).typedValue) {
                        return (0, utils_expression_evaluator_1.bool)(true);
                    }
                }
                catch (error) {
                    // If an error occurs, store it for later.
                    lessThanError = error;
                }
                // Then check if they are equal, and return if so.
                if (this.equalityFunction.applyOnTerms([first, second], exprEval)
                    .typedValue) {
                    return (0, utils_expression_evaluator_1.bool)(true);
                }
                // If less than produced an error and equals was false, throw the error.
                if (lessThanError) {
                    throw lessThanError;
                }
                // In all other cases, return false
                return (0, utils_expression_evaluator_1.bool)(false);
            })
                .collect(),
        });
        this.equalityFunction = equalityFunction;
        this.lessThanFunction = lessThanFunction;
    }
}
exports.TermFunctionLesserThanEqual = TermFunctionLesserThanEqual;
//# sourceMappingURL=TermFunctionLesserThanEqual.js.map